import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { fadeIn } from "../style/ani";
import { ClickToStart } from "./ClickToStart";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100vh;

   @media (max-width: 748px) {
    height: -webkit-fill-available;
    height: fill-available;
    height: calc(var(--vh, 1vh) * 100);
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: relative;
  max-height: 100vh;
  height: 100vh;
  background-position: center;
  background-size: cover;
  width: 100vw;
  max-width: 500px;
  opacity: 1;
  /* animation: ${fadeIn} ease-in-out forwards;
  animation-delay: 500ms;
  animation-duration: 1s; */

  @media (max-width: 748px) {
    height: -webkit-fill-available;
    height: fill-available;
    height: calc(var(--vh, 1vh) * 100);
  }
`;

const BottomContainer = styled.div`
  position: absolute;
  padding: 80px;
  padding-bottom: 40px;
  bottom: 0px;
  z-index: 2;
  font-size: 20px;
  font-weight: bold;
  color: white;
  text-align: left;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`;

const HeadText = styled.div`
  font-size: 35px;
  margin-top: 80px;
  color: white;
  @media (max-width: 500px) {
    font-size: 28px;
  }
`;

const Desc1 = styled.div`
  font-size: 15px;
  text-align: center;
  @media (max-width: 500px) {
    font-size: 13px;
  }
`

const Desc2 = styled.div`
  font-size: 20px;
  @media (max-width: 500px) {
    font-size: 18px;
  }
`


export function MainImage({ enter }: { enter: () => void }) {
  const [oneSecPassed, setOneSecPassed] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setOneSecPassed(true);
    }, 1000);
  }, []);


  const TopContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 2;
  `;

  const HeadSubText = styled.div`
    font-size: 20px;
    margin-top: 10px;
    color: white;
    @media (max-width: 500px) {
      font-size: 17px;
    }
  `;

 

  return (
    <Container>
      <ImageWrapper >
        <video
          autoPlay
          muted
          playsInline
          src="/video/wedding.mp4"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 1,
          }}
          controls={false}
        />
        <TopContainer>
          <HeadText>Welcome to Our Wedding</HeadText>
          <HeadSubText>차이새 ﹒ 김민지</HeadSubText>
        </TopContainer>

        <BottomContainer>
          <Desc1
          >
            <Desc2
            >
              2023.04.22 6:30 PM
            </Desc2>

            <div style={{ paddingTop: "5px" }}>세빛섬 플로팅아일랜드</div>
          </Desc1>
          <ClickToStart enter={enter} />
        </BottomContainer>
      </ImageWrapper>
    </Container>
  );
}
